import { PawPrint, MapPin, Heart, ShieldCheck, Users, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-cream" data-testid="about-page">
      {/* Hero */}
      <div className="bg-dark-brown text-cream py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <PawPrint className="w-12 h-12 text-rust mx-auto mb-4" />
          <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-4">About Pets Valley</h1>
          <p className="font-body text-cream/60 text-lg max-w-xl mx-auto">Anantnag's premier cat shop — serving cat lovers with love, quality, and genuine care since 2019.</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-8 py-16">
        {/* Story */}
        <section className="mb-16">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <span className="font-body text-xs uppercase tracking-[0.2em] text-rust font-medium">Our Story</span>
              <h2 className="font-heading text-2xl sm:text-3xl font-bold text-dark-brown mt-2 mb-6">From a Small Shop to Kashmir's Most Trusted Cat Destination</h2>
              <p className="font-body text-light-brown leading-relaxed mb-4">
                Pets Valley started as a small pet shop in Mattan Chowk, Anantnag, with a simple mission: to provide healthy cats and quality pet products to the people of South Kashmir.
              </p>
              <p className="font-body text-light-brown leading-relaxed mb-4">
                Over the past 10+ years, we've grown into a trusted destination for cat lovers, offering everything from premium cat breeds to nutritious food, accessories, grooming products, and professional grooming services.
              </p>
              <p className="font-body text-light-brown leading-relaxed">
                We believe every cat deserves a loving home and the best care possible. That's why we health-check, vaccinate, and deworm all our cats before they join your family.
              </p>
            </div>
            <div className="relative">
              <img src="https://images.pexels.com/photos/32727347/pexels-photo-32727347.jpeg" alt="About Pets Valley" className="rounded-2xl w-full h-80 object-cover" />
              <div className="absolute -bottom-4 -left-4 bg-rust text-cream rounded-xl p-4 shadow-lg">
                <div className="font-heading text-2xl font-bold">10+</div>
                <div className="font-body text-xs">Years of Service</div>
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="mb-16">
          <div className="text-center mb-10">
            <span className="font-body text-xs uppercase tracking-[0.2em] text-rust font-medium">What We Stand For</span>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold text-dark-brown mt-2">Our Values</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: Heart, title: 'Love & Care', desc: 'Every cat in our shop is treated with love. We ensure they are healthy, happy, and ready for their new home.' },
              { icon: ShieldCheck, title: 'Quality Guaranteed', desc: 'We source only premium products from trusted brands. No compromises on your cat\'s health.' },
              { icon: Users, title: 'Community First', desc: 'We serve dealers, pet shops, and families across South Kashmir with wholesale and retail pricing.' },
              { icon: Star, title: 'Expert Guidance', desc: 'Our experienced team helps you choose the right breed, food, and products for your lifestyle.' },
              { icon: MapPin, title: 'Local Roots', desc: 'Proudly based in Mattan Chowk, Anantnag. Easily accessible and always stocked.' },
              { icon: PawPrint, title: 'Cat Specialists', desc: 'We specialize in cats — from breeds and nutrition to grooming and health. Cats are our passion.' },
            ].map(v => (
              <div key={v.title} className="bg-white rounded-xl border border-border-custom p-6 hover:shadow-md transition-all duration-300 hover:-translate-y-1">
                <div className="w-12 h-12 rounded-xl bg-pale flex items-center justify-center mb-4"><v.icon className="w-6 h-6 text-rust" /></div>
                <h3 className="font-body font-semibold text-dark-brown mb-2">{v.title}</h3>
                <p className="font-body text-sm text-light-brown leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Visit CTA */}
        <section className="bg-dark-brown rounded-2xl p-10 text-center text-cream">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold mb-4">Visit Us Today</h2>
          <p className="font-body text-cream/60 mb-2">Mattan Chowk, Anantnag, Jammu & Kashmir — 192101</p>
          <p className="font-body text-cream/60 mb-6">Mon-Sat: 9AM-8PM | Sunday: 10AM-6PM</p>
          <div className="flex gap-3 justify-center flex-wrap">
            <Link to="/products"><Button className="bg-rust hover:bg-rust/90 text-cream font-body rounded-full px-8">Shop Now</Button></Link>
            <Link to="/services"><Button variant="outline" className="border-cream/30 text-cream hover:bg-cream/10 font-body rounded-full px-8">Our Services</Button></Link>
            <Link to="/contact"><Button variant="outline" className="border-cream/30 text-cream hover:bg-cream/10 font-body rounded-full px-8">Contact Us</Button></Link>
          </div>
        </section>
      </div>
    </div>
  );
}
